export default "__VITE_ASSET__ZXpMMKR5__"